import { createStore } from 'zustand/vanilla';
import { devtools, persist } from 'zustand/middleware';
import { AuthState, AuthStore } from './types';
import { AUTH_STORE_KEYS, defaultInitState } from './constants';

export const createAuthStore = () =>
   createStore<AuthStore>()(
      persist(
         devtools(set => ({
            ...defaultInitState,
            login: ({ user, accessToken }: Partial<AuthState>) => {
               if (user && accessToken)
                  set(() => ({
                     user,
                     accessToken,
                     isAuthenticated: true,
                  }));
            },
            logout: () =>
               set(() => ({
                  user: null,
                  accessToken: null,
                  isAuthenticated: false,
               })),
            updateProfile: (updatedUser: Partial<AuthState['user']>) =>
               set(state => ({
                  ...state,
                  user: { ...state.user, ...updatedUser } as AuthState['user'],
               })),
         })),
         {
            name: AUTH_STORE_KEYS,
         },
      ),
   );
